export default __webpack_public_path__ + "static/media/TOMB-FTM.7659e3ec.png";